import { Card } from 'primereact/card';
import { SpeedDial } from 'primereact/speeddial';
import { MenuItem } from 'primereact/menuitem';
import cv from '../content/TamiozzoCV.pdf';
import laga from '../assets/images/logo_laga.png';
import { useNavigate } from 'react-router';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';

function HomePage() 
{
	const navigate = useNavigate();
	const items: MenuItem[] = [
        {
            label: 'Lemniscates',
            icon: 'pi pi-pencil',
            command: () => { navigate('/lemniscates'); }
        },
		{
            label: 'Pictures',
            icon: 'pi pi-camera',
            command: () => { navigate('/photo'); }
        },
	];
	return (
	<div className='home_content'>
		<div style={{ position: 'relative', height: '2rem' }}>
			<Tooltip target=".speeddial-home .p-speeddial-action" position="bottom" />
			<SpeedDial model={items} direction="right" className='speeddial-home' style={{top: '-.5rem', left: '0' }} />
		</div>
		<Card className='home_card' title="Contact" pt={{title: {className:'home_card_title'}}}>
			<div className='flex flex-row'>
				<div className='flex-grow-1'>
					<p>
						<a href='https://www.univ-spn.fr/' target='_blank' rel="noreferrer">Université Sorbonne Paris Nord</a>,&nbsp;
						<a href='https://galilee.univ-paris13.fr/' target='_blank' rel="noreferrer">Institut Galilée</a>,&nbsp;<a href='https://www.math.univ-paris13.fr/laga/index.php/fr/' target='_blank' rel="noreferrer">LAGA</a></p>
					<p>
						<a href='https://www.math.univ-paris13.fr/laga/index.php/fr/aga' target='_blank' rel="noreferrer">Équipe d'Arithmétique et Géométrie Algébrique</a>
					</p>
					<p>Office D313</p>
					<p>Email: tamiozzo[at]math[dot]univ-paris13[dot]fr
						<Button icon="pi pi-copy" rounded text style={{width:'1.8rem', height:'1.8rem', color:'black', marginLeft:'6px', verticalAlign:'baseline'}} onClick={()=>{navigator.clipboard.writeText('tamiozzo@math.univ-paris13.fr')}}/>
					</p>
					<p><a href={cv} target='_blank' rel="noreferrer">CV</a></p>
				</div>
				<div>
					<img src={laga} alt='LAGA' className='logo_laga'></img>
				</div>
			</div>
		</Card>
		<Card className='home_card ' title="Research interests" pt={{title: {className:'home_card_title'}}}>
			<div className="home_item">
				<i className="pi pi-chevron-right" style={{ fontSize: '.8rem' }}></i>
				<span>Rational points and cycles on algebraic varieties and their relation with L-functions (Bloch-Kato, Soulé-Tate conjectures).</span>
			</div>
			<div className="home_item">
				<i className="pi pi-chevron-right" style={{ fontSize: '.8rem' }}></i>
				<span>Geometry and cohomology of locally symmetric spaces.</span>
			</div>
			<div className="home_item">
				<i className="pi pi-chevron-right" style={{ fontSize: '.8rem' }}></i>
				<span>Vector bundles on algebraic curves, irregular connections and related moduli spaces.</span>
			</div>
		</Card>
	</div> );
}

export default HomePage;